import { call, put, takeLatest } from 'redux-saga/effects';
import { API } from '../api';
import {
  ADD_FORM,
  ADD_FORM_ERROR,
  ADD_FORM_SUCCESS,
  DELETE_FORM,
  DELETE_FORM_ERROR,
  DELETE_FORM_SUCCESS,
  FETCH_FORM,
  FETCH_FORM_FAIL,
  FETCH_FORM_SUCCESS,
  FETCH_CHARGERS,
  FETCH_CHARGERS_FAIL,
  FETCH_CHARGERS_SUCCESS,
  FETCH_FORMS,
  FETCH_FORMS_FAIL,
  FETCH_FORMS_SUCCESS,
  UPDATE_FORM,
  UPDATE_FORM_ERROR,
  UPDATE_FORM_SUCCESS,
  ASSIGN_CHARGER,
  ASSIGN_CHARGER_SUCCESS,
  ASSIGN_CHARGER_FAIL,
  CREATE_CHECKLIST,
  CREATE_CHECKLIST_SUCCESS,
  CREATE_CHECKLIST_FAIL,
  FETCH_FORMS_LIST,
  FETCH_FORMS_LIST_SUCCESS,
  FETCH_FORMS_LIST_FAIL,
  FETCH_STATION_WISE_FORMS,
  FETCH_STATION_WISE_FORMS_SUCCESS,
  FETCH_STATION_WISE_FORMS_FAIL,
  SUBMIT_FORM_SUCCESS,
  SUBMIT_FORM_FAIL,
  SUBMIT_FORM,
  VIEW_FORM_SUCCESS,
  VIEW_FORM_FAIL,
  VIEW_FORM,
  DOWNLOAD_CHECKLIST_FORM_SUCCESS,
  DOWNLOAD_CHECKLIST_FORM_FAIL,
  DOWNLOAD_CHECKLIST_FORM,
  DOWNLOAD_FULL_PDF,
  DOWNLOAD_FULL_PDF_SUCCESS,
  DOWNLOAD_FULL_PDF_FAIL,
  STATUS_CHANGE_SUCCESS,
  STATUS_CHANGE_FAIL,
  STATUS_CHANGE,
  DELETE_CHECKLIST_FORM,
  DELETE_CHECKLIST_FORM_SUCCESS,
  DELETE_CHECKLIST_FORM_FAIL,
  ASSIGN_TO_CONTRACTOR,
  ASSIGN_TO_CONTRACTOR_SUCCESS,
  ASSIGN_TO_CONTRACTOR_FAIL,
  ASSIGN_TO_MANAGER_SUCCESS,
  ASSIGN_TO_MANAGER_FAIL,
  ASSIGN_TO_MANAGER,
} from 'actions/formActions';
import fileDownload from 'js-file-download';

function* handleAddForm(action) {
  try {
    const response = yield call(API.addForm, action.payload);
    yield put({ type: ADD_FORM_SUCCESS, payload: response.data });
  } catch (e) {
    yield put({ type: ADD_FORM_ERROR, payload: { error: e } });
  }
}

function* handleAssignCharger(action) {
  try {
    const response = yield call(API.assignCharger, action.payload);
    yield put({ type: ASSIGN_CHARGER_SUCCESS, payload: response.data });
  } catch (e) {
    yield put({ type: ASSIGN_CHARGER_FAIL, payload: { error: e } });
  }
}

function* handleFetchChargers() {
  try {
    const response = yield call(API.fetchChargers);
    yield put({ type: FETCH_CHARGERS_SUCCESS, payload: response.data });
  } catch (e) {
    yield put({ type: FETCH_CHARGERS_FAIL, payload: { error: e } });
  }
}

function* handleFetchForms(action) {
  try {
    const response = yield call(API.fetchForms, action.payload);
    yield put({ type: FETCH_FORMS_SUCCESS, payload: response.data });
  } catch (e) {
    yield put({ type: FETCH_FORMS_FAIL, payload: { error: e } });
  }
}

function* handleFetchForm(action) {
  try {
    const response = yield call(API.fetchForm, action.payload);
    yield put({ type: FETCH_FORM_SUCCESS, payload: response.data });
  } catch (e) {
    yield put({ type: FETCH_FORM_FAIL, payload: { error: e } });
  }
}

function* handleUpdateForm(action) {
  try {
    const response = yield call(API.updateForm, action.payload);
    yield put({ type: UPDATE_FORM_SUCCESS, payload: response.data });
  } catch (e) {
    yield put({ type: UPDATE_FORM_ERROR, payload: { error: e } });
  }
}

function* handleDeleteForm(action) {
  try {
    yield call(API.deleteForm, action.payload);
    yield put({ type: DELETE_FORM_SUCCESS, payload: action.payload });
  } catch (e) {
    yield put({ type: DELETE_FORM_ERROR, payload: { error: e } });
  }
}

function* createChecklist(action) {
  try {
    const response = yield call(API.createChecklist, action.payload);
    yield put({ type: CREATE_CHECKLIST_SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: CREATE_CHECKLIST_FAIL, payload: { error: e } });
    action.cb && action.cb(e);
  }
}

function* fetchFromsList(action) {
  try {
    const response = yield call(API.fetchFromsList, action.payload);
    yield put({ type: FETCH_FORMS_LIST_SUCCESS, payload: response.data });
  } catch (e) {
    // Sanitize the error
    const error = {
      message: e.message,
      status: e.response?.status,
      data: e.response?.data,
    };
    yield put({ type: FETCH_FORMS_LIST_FAIL, payload: { error } });
  }
}



function* fetchStationWiseFroms(action) {
  try {
    const response = yield call(API.fetchStationWiseFroms, action.payload);
    yield put({ type: FETCH_STATION_WISE_FORMS_SUCCESS, payload: response.data });
  } catch (e) {
    // Sanitize the error
    const error = {
      message: e.message,
      status: e.response?.status,
      data: e.response?.data,
    };
    yield put({ type: FETCH_STATION_WISE_FORMS_FAIL, payload: { error } });
  }
}


function* submitForm(action) {
  try {
    const response = yield call(API.submitForm, action.payload);
    yield put({ type: SUBMIT_FORM_SUCCESS, payload: response.data });
  } catch (e) {
    // Sanitize the error
    const error = {
      message: e.message,
      status: e.response?.status,
      data: e.response?.data,
    };
    yield put({ type: SUBMIT_FORM_FAIL, payload: { error } });
  }
}


function* viewForm(action) {
  try {
    const response = yield call(API.viewForm, action.payload);
    yield put({ type: VIEW_FORM_SUCCESS, payload: response.data });
  } catch (e) {
    // Sanitize the error
    const error = {
      message: e.message,
      status: e.response?.status,
      data: e.response?.data,
    };
    yield put({ type: VIEW_FORM_FAIL, payload: { error } });
  }
}




function* approveForm(action) {
  try {
    const response = yield call(API.approveForm, action.payload);
    yield put({ type: STATUS_CHANGE_SUCCESS, payload: response.data });
  } catch (e) {
    // Sanitize the error
    const error = {
      message: e.message,
      status: e.response?.status,
      data: e.response?.data,
    };
    yield put({ type: STATUS_CHANGE_FAIL, payload: { error } });
  }
}


function* downloadChecklistForm(action) {
  try {
    const { formId, formName, userName, stationId } = action.payload;
    const response = yield call(API.downloadChecklistForm, { formId, formName, userName, stationId });

    // response.data could be a Blob of type 'application/pdf' or 'text/html'
    if (response.data && response.data.type === 'text/html') {
      const url = URL.createObjectURL(response.data);
      const newTab = window.open(url, '_blank');
      if (newTab) {
        newTab.onload = () => {
          newTab.document.title = `${stationId}_${formName}`;
          setTimeout(() => {
            newTab.print();
          }, 500);
        };
      } else {
        console.error('Failed to open new tab for PDF preview. Please check pop-up blocker settings.');
      }
    } else {
      // Fallback for downloading actual PDFs
      yield call(fileDownload, response.data, `${stationId}_${formName}.pdf`);
    }

    // Optionally dispatch success without blob
    yield put({ type: DOWNLOAD_CHECKLIST_FORM_SUCCESS }); // No payload needed
  } catch (e) {
    const error = {
      message: e.message,
      status: e.response?.status,
      data: e.response?.data,
    };
    yield put({ type: DOWNLOAD_CHECKLIST_FORM_FAIL, payload: { error } });
  }
}

function* downloadFullPDF(action) {
  try {
    const { stationId } = action.payload;
    const response = yield call(API.downloadFullPDFByStation, { stationId });

    if (response.data) {
      const url = URL.createObjectURL(response.data);
      const newTab = window.open(url, '_blank');
      if (newTab) {
        newTab.onload = () => {
          newTab.document.title = `${stationId}_Full_Checklist`;
          setTimeout(() => {
            newTab.print();
          }, 500);
        };
      } else {
        console.error('Failed to open new tab for PDF preview. Please check pop-up blocker settings.');
      }
    }

    yield put({ type: DOWNLOAD_FULL_PDF_SUCCESS });
  } catch (e) {
    const error = {
      message: e.message,
      status: e.response?.status,
      data: e.response?.data,
    };
    yield put({ type: DOWNLOAD_FULL_PDF_FAIL, payload: { error } });
  }
}

function* deleteChcecklistForm(action) {
  try {
    const response = yield call(API.deleteChcecklistForm, action.payload);
    yield put({ type: DELETE_CHECKLIST_FORM_SUCCESS, payload: response.data });
  } catch (e) {
    // Sanitize the error
    const error = {
      message: e.message,
      status: e.response?.status,
      data: e.response?.data,
    };
    yield put({ type: DELETE_CHECKLIST_FORM_FAIL, payload: { error } });
  }
}



function* assignToContractor(action) {
  try {
    const response = yield call(API.assignToContractor, action.payload);
    yield put({ type: ASSIGN_TO_CONTRACTOR_SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    // Sanitize the error
    const error = {
      message: e.message,
      status: e.response?.status,
      data: e.response?.data,
    };
    yield put({ type: ASSIGN_TO_CONTRACTOR_FAIL, payload: { error } });
    action.cb && action.cb(error);
  }
}

function* assignToManager(action) {
  try {
    const response = yield call(API.assignToManager, action.payload);
    yield put({ type: ASSIGN_TO_MANAGER_SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    // Sanitize the error
    const error = {
      message: e.message,
      status: e.response?.status,
      data: e.response?.data,
    };
    yield put({ type: ASSIGN_TO_MANAGER_FAIL, payload: { error } });
    action.cb && action.cb(error);
  }
}


function* form() {
  yield takeLatest(ADD_FORM, handleAddForm);
  yield takeLatest(ASSIGN_CHARGER, handleAssignCharger);
  yield takeLatest(FETCH_CHARGERS, handleFetchChargers);
  yield takeLatest(FETCH_FORMS, handleFetchForms);
  yield takeLatest(FETCH_FORM, handleFetchForm);
  yield takeLatest(UPDATE_FORM, handleUpdateForm);
  yield takeLatest(DELETE_FORM, handleDeleteForm);
  yield takeLatest(CREATE_CHECKLIST, createChecklist);
  yield takeLatest(FETCH_FORMS_LIST, fetchFromsList);
  yield takeLatest(FETCH_STATION_WISE_FORMS, fetchStationWiseFroms);
  yield takeLatest(SUBMIT_FORM, submitForm);
  yield takeLatest(VIEW_FORM, viewForm);
  yield takeLatest(DOWNLOAD_CHECKLIST_FORM, downloadChecklistForm);
  yield takeLatest(DOWNLOAD_FULL_PDF, downloadFullPDF);
  yield takeLatest(STATUS_CHANGE, approveForm);
  yield takeLatest(DELETE_CHECKLIST_FORM, deleteChcecklistForm);
  yield takeLatest(ASSIGN_TO_CONTRACTOR, assignToContractor);
  yield takeLatest(ASSIGN_TO_MANAGER, assignToManager);

}
export default form;
